import React, { ReactNode } from 'react';
import { cn } from '../utils/cn';
import { PageHeader } from './PageHeader';

interface PageContainerProps {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  eyebrow?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  title,
  subtitle,
  eyebrow,
  actions,
  className = ""
}) => {
  return (
    <div className={cn('space-y-4', className)}>
      {title ? <PageHeader title={title} subtitle={subtitle} eyebrow={eyebrow} actions={actions} /> : null}
      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
